import {IValidator} from './IValidator';
import {ScaleInfo} from '../ScaleInfo';

declare const THREE: any;

export class WallChildrenJutOutValidator implements IValidator {

  constructor(private scaleInfo: ScaleInfo) {
  }

  private static isBetweenPoints(start, end, pointToCheck) {
    const ab = start.clone().sub(pointToCheck).normalize();
    const bc = end.clone().sub(pointToCheck).normalize();
    return ab.dot(bc) < 0;
  }

  private staticSidePoint(wall, wallSize) {
    const point = this.scaleInfo.localScaleDirection.clone().negate().multiply(wallSize);
    wall.updateMatrixWorld();
    return wall.localToWorld(point).setY(0);
  }

  private dynamicSidePoint(staticSidePoint, wallSize) {
    const len = this.scaleInfo.localScaleDirection.clone().multiply(wallSize).length();
    const offset = this.scaleInfo.worldScaleDirection.clone().multiplyScalar(len);
    return staticSidePoint.clone().add(offset);
  }

  private isInsideWall(wallChildren, start, end) {
    const {worldScaleDirection, localScaleDirection} = this.scaleInfo;
    return wallChildren.find(child => {
      child.updateMatrixWorld();
      const {length, height} = child.userData.entity;
      const childPoint = localScaleDirection
        .clone()
        .multiply(new THREE.Vector3(length / 2, height / 2, 0))
        .applyMatrix4(child.matrixWorld);
      const childPointToEnd = childPoint.clone().sub(end);
      const offset = childPointToEnd.projectOnVector(worldScaleDirection);
      const projectedPoint = end.clone().add(offset);
      return !WallChildrenJutOutValidator.isBetweenPoints(
        start,
        end,
        projectedPoint
      );
    }) === undefined;
  }

  validate(wall, newSize, newPosition) {
    const {width: wallLength, height} = wall.userData.config;
    const currentSize = new THREE.Vector3(wallLength / 2, height / 2, 0);
    const staticPoint = this.staticSidePoint(wall, currentSize);
    const dynamicSidePoint = this.dynamicSidePoint(staticPoint, newSize);
    return this.isInsideWall(wall.children, staticPoint, dynamicSidePoint);
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/Validators/WallChildrenJutOutValidator.ts